import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { OccupationModal } from '../../../sharedcomponents/commonservice/occupation/Occupation/Occupation.Modal';

import { AppSettings } from '../../../sharedcomponents/_common/constants/app.constants';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
@Injectable()
export class mywalletloyaltycard {
    constructor(private http: Http,
        private utilserv: utilityService) { }
    //1 Envolpe for
    getloyaltycardlistservice() {
        return this.utilserv.soapPostwithoutAction(this.getloyaltycardimageenvolpe(),
            AppSettings.ICEUserMgmtService);

    };

    getloyaltycardimageenvolpe() {
        let envelope: string = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
          <s:Header>
            <a:Action s:mustUnderstand="1">http://tempuri.org/IICEUserMgmt/GetLoyaltyCardImage</a:Action>
            <a:MessageID>urn:uuid:7cd09f89-2152-49b6-b17f-b374d3e8aae8</a:MessageID>
            <a:ReplyTo>
              <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
            </a:ReplyTo>
          </s:Header>
          <s:Body>
            <CustomerInfoRequest xmlns="http://tempuri.org/">
              <AdditionalLastName>sd</AdditionalLastName>
             <Address xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.Contract" i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
              <Checksum i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
              <CustomerEmail i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
              <CustomerEmployer i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
              <CustomerOccupation i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
              <CustomerPwd i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
              <DOB i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
              <FirstName i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
              <KeyUID i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
              <LanguageCode>${sessionStorage.langCode}</LanguageCode>
              <LastName i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
              <LastOrderNumber i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
              <LoyaltyCardNumber i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
              <MiddleName i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
              <MobileNumber></MobileNumber>
              <PreferCountryCode></PreferCountryCode>
              <ReceivingAgentId></ReceivingAgentId>
              <RegistartionCode></RegistartionCode>
              <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.Common.Contract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                    <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                    <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
              </Session>
             <UserID i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
              <UserVerifiedBy i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
            </CustomerInfoRequest>
          </s:Body>
        </s:Envelope>`
        return envelope

    }









}







// WEBPACK FOOTER //
// ./src/app/_services/mywallet/walletloyaltycard/mywallet.loyaltycard.service.ts